<template>
    <div class="landing-page b-container fluid vh-100 d-flex justify-content-center align-items-center" :class="gradientColor">
            <div class="outer-div overflow-hidden">
                <div class="row align-items-center h-100 mx-3 rounded" :class="gradientColor">
                    <div class="welcome1 h-100 col-lg-6 col-md-12  p-0 overflow-auto bg-white rounded-left ">
                        <div class="mx-2 h-100 bg-white d-flex align-items-center ">
                            <div class="h-50 ml-5">
                                <h1 class="mb-4 display-3">Welcome back, <span class="d-inline-block font-weight-bold" :class="textColor">{{ userName }}</span>!</h1>
                                <p class="textBlack" v-if="recentActivities.length <= 0 ">No recent activities.</p>
                                <p class="textBlack" v-else>Here are your recent activities:</p>
                                <ul>
                                    <li v-for="(user_activity, index) in recentActivities" :key="index"  :class="textColor">
                                        <span class="textBlack">{{ user_activity.activity.action }} </span>
                                      
                                        <span v-if="user_activity.activity.category == 'Documents' || user_activity.activity.category == 'Sales Channel Management' ||  user_activity.activity.category == 'Sales Channel Promotions'" :class="textColor"> 
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span>
                                        <span v-else-if="user_activity.activity.category == 'Master Data Management'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span>        
                                        <span v-else-if="user_activity.activity.category == 'Reports'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span>        
                                        <span v-else-if="user_activity.activity.category == 'POS Settings'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span> 
                                        <span v-else-if="user_activity.activity.category == 'User Management'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span>
                                        <span v-else-if="user_activity.activity.category == 'MMS Configuration Settings'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span> 
                                        <span v-else-if="user_activity.activity.category == 'My Wavelets'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span> 
                                        <span v-else-if="user_activity.activity.category == 'My Apps'" :class="textColor">
                                            <router-link :to="user_activity.site"> {{ user_activity.activity.system_module }} </router-link>
                                        </span> 
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 h-100  p-0">
                        <div class="welcome2 h-100 mx-2 rounded-right" :style="bgImage"></div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import secureStorage from '../controllers/secureStorage.js'
import { mapState } from 'vuex'
import HTTPRequest from '../controllers/httpRequest.js'

export default{
    computed:{
        ...mapState(['endPoint']),
        
        bgImage(){
          return `background-image: url(${require('../assets/background/'+ this.businessTypeCode +'/instore.png')})`;
        },
        gradientColor(){
            if(this.businessTypeCode == 'SUP'){
                return "bg-sup"
            }else if(this.businessTypeCode == 'FNB'){
                return "bg-fnb"
            }else if(this.businessTypeCode == 'BOU'){
                return "bg-bou"
            }else if(this.businessTypeCode == 'DRU'){
                return "bg-dru"
            }else if(this.businessTypeCode == 'HIM'){
                return "bg-him"
            }
        },
        textColor(){
           if(this.businessTypeCode == 'SUP'){
                return "text-sup"
            }else if(this.businessTypeCode == 'FNB'){
                return "text-fnb"
            }else if(this.businessTypeCode == 'BOU'){
                return "text-bou"
            }else if(this.businessTypeCode == 'DRU'){
                return "text-dru"
            }else if(this.businessTypeCode == 'HIM'){
                return "text-him"
            } 
        },
    },
    mounted: async function () {
        var userId = secureStorage.getItem("userId")
        var user_activities = await HTTPRequest.getRequest(this.endPoint + 'user_activities?user_id=' + userId, null)
        this.recentActivities = user_activities;
    },
    data(){
        return{
            businessTypeCode: JSON.parse(localStorage.getItem("businessTypeCode")),
            userName: secureStorage.getItem("userName"),
            recentActivities: [],
            baseURL: window.location.origin
        }
    },
}
</script>

<style scoped>

.outer-div{
    height: 60%;
    width: 100%;
}
ul{margin-left: -20px;}

.textBlack{color: #32325d;}

.bg-sup{background: linear-gradient(89deg, #4AC9F1, #297BF3);}
.bg-fnb{background: linear-gradient(89deg, #F4AB31, #F0653A);}
.bg-bou{background: linear-gradient(89deg, #B453D3, #6636DD);}
.bg-dru{background: linear-gradient(89deg, #57CD88, #56CFCB);}
.bg-him{background: linear-gradient(89deg, #EA5B31, #E93559);}

 li.text-sup::marker, .text-sup{color: #297BF3;}
 li.text-fnb::marker, .text-fnb{color: #F0653A;}
 li.text-bou::marker, .text-bou{color: #6636DD;}
 li.text-dru::marker, .text-dru{color: #56CFCB;}
 li.text-him::marker, .text-him{color: #E93559;}
 
.welcome2{
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
</style>
